// pages/Home.js
import React, { useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Slider from '../components/Slider';
import Departments from '../components/Departments';
import OurMethod from '../components/OurMethod';
import Expertise from '../components/Expertise';
import Achievements from '../components/Achievements';
import Team from '../components/Team';
import Counter from '../components/Counter';
import FAQ from '../components/FAQ';
import Testimonials from '../components/Testimonials';

const Home = () => {
  const { t } = useLanguage();
  const featuresRef = useRef(null);

  return (
    <div className="home-page">
      <Slider featuresRef={featuresRef} />
      <div ref={featuresRef}>
        <Departments />
      </div>
      <OurMethod />
      <Expertise />
      <Achievements />
      <Team />
      <Counter />
      <FAQ />
      <Testimonials />
    </div>
  );
};

export default Home;